/** How a story opened from a page takes over the screen. */
export const STORY_TRANSITIONS = ["overlay", "push"] as const;

export type StoryTransition = (typeof STORY_TRANSITIONS)[number];

export const DEFAULT_STORY_TRANSITION: StoryTransition = "push";

interface StoryMotion {
  readonly ms: number;
  readonly easing: string;
}

/** The story's motion for each transition: in and out, and how far the page moves aside. */
export const STORY_MOTION: Record<
  StoryTransition,
  { in: StoryMotion; out: StoryMotion; pageShift: string; loopMs: number }
> = {
  overlay: {
    in: { ms: 400, easing: "cubic-bezier(0.2, 0.8, 0.2, 1)" },
    out: { ms: 400, easing: "cubic-bezier(0.4, 0, 1, 1)" },
    pageShift: "-8%",
    loopMs: 2500,
  },
  push: {
    in: { ms: 400, easing: "cubic-bezier(0.65, 0, 0.35, 1)" },
    out: { ms: 400, easing: "cubic-bezier(0.65, 0, 0.35, 1)" },
    pageShift: "-100%",
    loopMs: 2700,
  },
};

/** CSS custom properties that carry a transition's motion into its stylesheets. */
export function storyMotionVars(transition: StoryTransition) {
  const motion = STORY_MOTION[transition];
  return {
    "--story-in-ms": `${motion.in.ms}ms`,
    "--story-in-easing": motion.in.easing,
    "--story-out-ms": `${motion.out.ms}ms`,
    "--story-out-easing": motion.out.easing,
    "--story-page-shift": motion.pageShift,
    "--story-loop-ms": `${motion.loopMs}ms`,
  };
}
